import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameResultDetail extends BaseModelAPI {
	static entity = 'stockopnameresultdetail';
	static entityName = 'stockopnameresultdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockOpnameResultId = '';
			this.stockOpnameResult = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.qtySystem = 0;
			this.totalPriceQtySystem = 0;
			this.qtyActual = 0;
			this.totalPriceQtyActual = 0;
			this.totalDifferenceQty = 0;
			this.totalDifferencePrice = 0;
			this.differenctPercentage = 0;
			this.scannedDate = '';
			this.scannedById = '';
			this.scannedBy = {};
			this.stockOpnameDetailId = '';
			this.stockOpnameDetail = {};
			this.remarks = '';
			this.partPrice = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}